import { DashboardLayout } from '@/components/layout/DashboardLayout';
import DataRoomComponent from '@/components/dataroom/DataRoom';
import DataRoomSharing from '@/components/dataroom/DataRoomSharing';
import DataRoomAccessAnalytics from '@/components/dataroom/DataRoomAccessAnalytics';
import DataRoomVersioning from '@/components/dataroom/DataRoomVersioning';
import DealRoomIntegration from '@/components/dataroom/DealRoomIntegration';
import { DataRoomAnalytics } from '@/components/dataroom/DataRoomAnalytics';
import { DealClosingPack } from '@/components/dataroom/DealClosingPack';
import { InvestorReporting } from '@/components/investor/InvestorReporting';
import FundraisingFolderView from '@/components/dataroom/FundraisingFolderView';
import { useTenantStore } from '@/hooks/useTenantStore';
import { Card, CardContent } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';

export default function DataRoom() {
  const { tenantId } = useTenantStore();

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">Data Room</h1>
          <p className="text-muted-foreground mt-1">
            Securely store and manage corporate documents with AI-powered insights
          </p>
        </div>

        {tenantId ? (
          <>
            <div data-tour="upload-zone">
              <DataRoomComponent companyId={tenantId} />
            </div>
            <FundraisingFolderView companyId={tenantId} />
            <DataRoomVersioning companyId={tenantId} />
            <div data-tour="sharing-controls">
              <DataRoomSharing companyId={tenantId} />
            </div>
            <DataRoomAccessAnalytics companyId={tenantId} />
            <DealRoomIntegration companyId={tenantId} />
            <DealClosingPack companyId={tenantId} />
            <DataRoomAnalytics companyId={tenantId} />
            <InvestorReporting companyId={tenantId} />
          </>
        ) : (
          <Card>
            <CardContent className="flex items-center gap-3 p-6">
              <AlertCircle className="h-5 w-5 text-muted-foreground" />
              <p className="text-muted-foreground">
                Please select a company to view the data room.
              </p>
            </CardContent>
          </Card>
        )}
      </div>
    </DashboardLayout>
  );
}
